<template>
  <el-dialog
    :visible="true"
    width="500px"
    @close="$router.replace('/todos')"
    :close-on-click-modal="false"
  >
    <div
      slot="title"
    >
      {{ title }}
    </div>
    <el-tabs
      v-model="activeName"
      v-loading="loading">
      <el-tab-pane
        label="Alapadatok"
        name="1">
        <el-table
          :data="todoData"
          :show-header="false"
          border
        >
          <el-table-column
            prop="label"
          >
            <template slot-scope="scope">
              <strong>{{ scope.row.label }}</strong>
            </template>
          </el-table-column>
          <el-table-column
            prop="value"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.tagType || 'danger'"
                size="small"
                v-if="scope.row.tag"
              >
                {{ scope.row.value }}
              </el-tag>
              <span v-if="!scope.row.tag" style="word-break: normal;">{{ scope.row.value }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="Napló"
        name="2"
      >
        <activity-timeline
          v-if="todo && todo.activities"
          :activities="todo.activities"
          :formatters="activityFormatters"
          :propsMap="propsMap"
        />
      </el-tab-pane>
    </el-tabs>
    <div
      slot="footer"
      class="dialog-footer"
      v-can="['todo.delete', 'todo.update']"
    >
      <el-button
        @click="$router.replace('/todos/update/' + todo.id)"
        type="primary"
        icon="el-icon-edit"
        v-can="'todo.update'"
      >
        Módosítás
      </el-button>
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteTodo()"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          icon="el-icon-delete"
          type="danger"
          style="margin-left: 5px;"
        >
          Törlés
        </el-button>
      </el-popover>
    </div>
  </el-dialog>
</template>

<script>
import ActivityTimeline from '../ActivityTimeline';

export default {
  components: { ActivityTimeline },
  props: ['todoId'],
  data() {
    return {
      activeName: '1',
      deleteButtonLoader: false,
      deleteConfirmVisible: false,
      title: 'Betöltés folyamatban...',
      loading: false,
      buttonLoading: false,
      todo: {},
      todoData: [],
      activityFormatters: {
        status: status => ({
          value: this.getStatusValue(status),
          tag: status === 'todo' ? 'danger' : (status === 'in-progress' ? 'warning' : 'success'),
        })
      },
      propsMap: {
        'title': 'Cím',
        'status': 'Státusz',
        'description': 'Leírás',
        'deadline': 'Határidő',
        'responsible_user': 'Felelős'
      },
    };
  },
  watch: {
    todoId(newVal) {
      this.activeName = '1';
      this.fetchData();
    },
  },

  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.todo = await axios.get(`api/todos/${this.todoId}`);
      this.title = this.todo.title;
      this.todoData = [
        {
          label: 'Cím',
          value: this.todo.title
        },
        {
          label: 'Státusz',
          value: this.getStatusValue(this.todo.status),
          tag: true,
          tagType: this.todo.status === 'todo' ? 'danger' : (this.todo.status === 'in-progress' ? 'warning' : 'success'),
        },
        {
          label: 'Leírás',
          value: this.todo.description || 'Nincs leírás',
          tag: !this.todo.description,
        },
        {
          label: 'Határidő',
          value: this.$options.filters.dateTime(this.todo.deadline)
        },
        {
          label: 'Felelős',
          value: this.todo.responsible_user.first_name + ' ' + this.todo.responsible_user.last_name
        },
        {
          label: this.todo.subscribers.length === 1 ? 'Feliratkozó' : 'Feliratkozók',
          value: this.todo.subscribers.length === 0 ? 'Nincs feliratkozó' : this.todo.subscribers.map(t => `${t.last_name} ${t.first_name} (@${t.username})`).join(', '),
          tag: this.todo.subscribers.length === 0,
        },
        {
          label: 'Létrehozó',
          value: this.todo.creator_user.first_name + ' ' + this.todo.creator_user.last_name
        },
        {
          label: 'Létrehozva',
          value: this.$options.filters.dateTime(this.todo.created_at)
        },
        {
          label: 'Módosítva',
          value: this.$options.filters.dateTime(this.todo.updated_at)
        },
      ];
      this.loading = false;
    },
    async deleteTodo() {
      this.deleteButtonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('todo/delete', this.todo.id);
        this.$store.dispatch('todo/fetchAll');
        this.$router.replace('/todos');
      } catch (e) {
      }
      this.deleteButtonLoader = false;
    },
    getStatusValue(status) {
      switch (status) {
        case 'in-progress':
          return 'Folyamatban';
        case 'done':
          return 'Kész';
        case 'todo':
          return 'Elintézendő';
      }
    }
  },
};
</script>
